import Cookies from "js-cookie";

// The authToken cookie on .ukvisajobs.com is the shared session - www reads it
// directly. localStorage here is only a mirror of it.
//
// Before this change the mirror was the source of truth: dozens of API .catch
// blocks clear localStorage and reload on ANY error (a 500, a timeout, a
// dropped connection), after which this function saw no local token and sent
// the user to sign in - while www, reading the cookie, still showed them logged
// in. Now: if the cookie is present, the mirror is rebuilt from it. If the
// cookie is gone, the session is gone.
//
// Circuit breaker: if the mirror was rebuilt very recently and has been cleared
// again, the server is rejecting the token itself. Then log out for real,
// cookie included, instead of reload-looping.

const REHYDRATED_AT_KEY = "authRehydratedAt";
const REHYDRATE_WINDOW_MS = 60 * 1000;
const TOKEN_TTL_MS = 30 * 24 * 60 * 60 * 1000; // matches the cookie's 30-day expiry

export function getAuthUserToken() {
  const cookieToken = Cookies.get("authToken");
  const token = localStorage.getItem("authToken");
  const expiry = localStorage.getItem("authTokenExpiry");

  // No cookie: no session. Anonymous visitors simply get null; a stale mirror
  // (user was logged in, cookie has since gone) is cleared and sent to sign in.
  if (!cookieToken) {
    if (token || expiry) {
      clearLocalMirror();
      redirectToSignin();
    }
    return null;
  }

  const mirrorIsGood =
    token === cookieToken && expiry && Date.now() <= parseInt(expiry, 10);
  if (mirrorIsGood) return token;

  // Cookie present but the mirror is missing, stale or different: rebuild it.
  const last = parseInt(sessionStorage.getItem(REHYDRATED_AT_KEY) || "0", 10);
  if (Date.now() - last < REHYDRATE_WINDOW_MS) {
    // Rebuilt less than a minute ago and cleared again -> the token is being
    // rejected upstream. Real logout.
    clearLocalMirror();
    Cookies.remove("authToken", { domain: getCookieDomain(), path: "/" });
    sessionStorage.removeItem(REHYDRATED_AT_KEY);
    redirectToSignin();
    return null;
  }

  sessionStorage.setItem(REHYDRATED_AT_KEY, String(Date.now()));
  localStorage.setItem("authToken", cookieToken);
  localStorage.setItem("authTokenExpiry", String(Date.now() + TOKEN_TTL_MS));
  return cookieToken;
}

function clearLocalMirror() {
  localStorage.removeItem("authToken");
  localStorage.removeItem("authTokenExpiry");
}

// Helper: decide cookie domain (dev vs prod)
function getCookieDomain() {
  if (process.env.REACT_APP_ENV_MODE === "development") {
    return "localhost"; // works on localhost
  }
  return process.env.REACT_APP_DOMAIN; // works on production
}

// Small helper for redirect
function redirectToSignin() {
  if (typeof window !== "undefined") {
    window.location.href = process.env.REACT_APP_LOGIN_URL;
  }
}
